import React from 'react';
import { FiMenu, FiShoppingBag, FiSearch, FiCompass } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  return (
    <nav className="sticky top-0 z-50 bg-zinc-950/90 backdrop-blur-md border-b-2 border-zinc-800 uppercase tracking-widest text-sm font-bold">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <button className="lg:hidden text-zinc-100 hover:text-orange-500 transition-colors">
            <SafeIcon icon={FiMenu} className="w-6 h-6" />
          </button>
          
          <div className="hidden lg:flex gap-8">
            <a href="#gear" className="hover:text-orange-500 transition-colors">Gear</a>
            <a href="#apparel" className="hover:text-orange-500 transition-colors">Apparel</a>
            <a href="#field-tests" className="hover:text-orange-500 transition-colors">Field Tests</a>
          </div>
        </div>

        <div className="flex items-center gap-2 text-2xl font-black text-white tracking-tighter">
          <SafeIcon icon={FiCompass} className="text-orange-600 w-8 h-8" />
          <span>TRAIL<span className="text-orange-600">FORGE</span></span>
        </div>

        <div className="flex items-center gap-6">
          <button className="hidden sm:block text-zinc-100 hover:text-orange-500 transition-colors">
            <SafeIcon icon={FiSearch} className="w-5 h-5" />
          </button>
          <button className="flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-white px-4 py-2 transition-colors border border-orange-600">
            <SafeIcon icon={FiShoppingBag} className="w-5 h-5" />
            <span className="hidden sm:inline">CART (2)</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;